import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { mediaDesktop } from 'breakpoints';
import Typography from 'components/Typography';
import { Avatar, TitleContainer } from 'components/TitledAvatar/styled';

export const TopCollectorsList = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  justify-content: space-between;
  column-gap: 26px;
  margin: auto;

  ${mediaDesktop} {
    max-width: 100%;
    width: 998px;
  }
`;

export const TopCollectorsSection = styled.section`
  background: ${({ theme }) => theme.colors.black};
  padding: 42px 24px 0;
  width: 100%;

  ${mediaDesktop} {
    padding: 86px 24px 0;
  }
`;
export const CollectorNumber = styled(Typography)`
  white-space: nowrap;
`;

export const TopCollectorsHeadline = styled(Typography)`
  margin-top: 10px;
  margin-bottom: 32px;
  letter-spacing: 1px;
  text-align: left;

  ${mediaDesktop} {
    margin-top: 0;
    margin-bottom: 50px;
    line-height: 48px;
    text-align: center;
    letter-spacing: 2px;
  }
`;

export const CollectorWrapper = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 350px;
  width: 100%;
  margin: 0 0 26px;
  text-decoration: none;

  ${mediaDesktop} {
    max-width: 426px;
    margin: 0 0 45px;
  }

  ${Avatar} {
    align-self: start;
  }

  ${TitleContainer} {
    padding-top: 0;
    justify-items: flex-start;
  }
`;

export const CollectorTagWrapper = styled.div`
  text-align: center;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 7px;

  ${mediaDesktop} {
    gap: 10px;
  }
`;

export const UserTitleWrapper = styled(Typography)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 12px;
`;

export const UserNameWrapper = styled(UserTitleWrapper)`
  white-space: nowrap;
  margin-bottom: 5px;
  ${mediaDesktop} {
    margin-bottom: 10px;
  }
`;
